import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'

const GoodSelectReadNew = ({ options, required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)

	useEffect(() => {
		setValueDefault()
	}, [options])

	useEffect(() => {
		valid()
	}, [required, value])

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}
	
	const setValueDefault = () => {
		if (options.length > 0) {
			setValue(options[0].id)
			setValueForm(options[0].id)
			// dispatch(setBoxGoodId(goods[0].id))
		}
	}

  return (
	<MySelect
		value={value}
		label="Товар"
		labelId="select__good-label"
		id='select__good'
		onChange = {e => {
			setValueForm(e)
			setValue(e)
			// setEvent({...event, categoryId: e})
		}}
		nameField='Товар'
		// sx={{width: '200px'}}
		options={options && options.length > 0 ? options : []}
	/>
  )
}

export default GoodSelectReadNew